/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevAutoCalcRunDto
 */
export interface DevAutoCalcRunDto {
    /**
     * 
     * @type {Date}
     * @memberof DevAutoCalcRunDto
     */
    runDate: Date;
    /**
     * 
     * @type {string}
     * @memberof DevAutoCalcRunDto
     */
    runKey: string;
}

/**
 * Check if a given object implements the DevAutoCalcRunDto interface.
 */
export function instanceOfDevAutoCalcRunDto(value: object): value is DevAutoCalcRunDto {
    if (!('runDate' in value) || value['runDate'] === undefined) return false;
    if (!('runKey' in value) || value['runKey'] === undefined) return false;
    return true;
}

export function DevAutoCalcRunDtoFromJSON(json: any): DevAutoCalcRunDto {
    return DevAutoCalcRunDtoFromJSONTyped(json, false);
}

export function DevAutoCalcRunDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevAutoCalcRunDto {
    if (json == null) {
        return json;
    }
    return {
        
        'runDate': (new Date(json['runDate'])),
        'runKey': json['runKey'],
    };
}

export function DevAutoCalcRunDtoToJSON(json: any): DevAutoCalcRunDto {
    return DevAutoCalcRunDtoToJSONTyped(json, false);
}

export function DevAutoCalcRunDtoToJSONTyped(value?: DevAutoCalcRunDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'runDate': ((value['runDate']).toISOString()),
        'runKey': value['runKey'],
    };
}

